import styled from 'styled-components';

const Wrapper = styled.article`
  margin-bottom: 30px;

  width: 23%;

  .container {
    position: relative;
    background: white;
    border-radius: var(--radius);
    width: 100%;
    padding: 0px;
  }
  img {
    width: 100%;
    display: block;
    object-fit: cover;
    border-radius: var(--radius);
    transition: var(--transition);
    height: 400px !important;
  }
  .link {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: var(--clr-primary-5);
    display: flex;
    align-items: center;
    justify-content: center;
    width: 2.5rem;
    height: 2.5rem;
    border-radius: 50%;
    transition: var(--transition);
    opacity: 0;
    cursor: pointer;
    svg {
      font-size: 1.25rem;
      color: var(--clr-white);
    }
  }
  .container:hover .link {
    opacity: 1;
  }
  footer {
    margin-top: 1rem;
    display: flex;
    flex-direction: column;
  }
  footer h5,
  footer p {
    margin-bottom: 0;
    font-weight: 400;
  }

  footer p {
    color: var(--clr-primary-5);
    letter-spacing: var(--spacing);
  }

  .removeButton{
    width: 90%;
    border: none;
    border-radius: 5px;
    background-color: #ffe326;
    padding-top: 5px;
    padding-bottom: 5px;
    margin-top: 5px
  }

  @media (max-width: 1060px) {
    width: 30%;
  }

  @media (max-width: 800px) {
    width: 45%;
  }

  @media (max-width: 800px) {
    img { 
      height: 300px !important;
    }
  }

  @media (max-width: 470px) {
    img { 
      height: 240px !important;
    }
  }

  @media (max-width: 360px) {
    img { 
      height: 180px !important;
    }
  }

  

`;

export default Wrapper;
